import React from "react";
import { HubOutlined, InfoOutlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import TopologicalView from "fond/topologicalView/TopologicalView";
import { useTopologicalViewContext } from "fond/topologicalView/TopologicalViewContext";
import { NonIdealState } from "fond/widgets";

import { ITabProps } from "./factory";

/**
 * Main widget component that determines the content rendered within the tab
 */
export const Widget: React.FC<ITabProps> = ({ node }: ITabProps) => {
  const {
    isEnabled,
    isAvailable,
    data: { isError, isFetching },
  } = useTopologicalViewContext();

  if (!isEnabled) {
    return <NonIdealState size="small" icon={<InfoOutlined />} description={<>This feature is not currently available.</>} />;
  }

  if (!isAvailable) {
    return <NonIdealState size="small" icon={<InfoOutlined />} description={<>The topological view is not currently available.</>} />;
  }

  if (isError) {
    return <NonIdealState size="small" icon={<InfoOutlined />} description={<>The topological view cannot currently be displayed.</>} />;
  }

  if (isFetching) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100%" sx={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
        <CircularProgress />
      </Box>
    );
  }
  return <TopologicalView />;
};

/**
 * Icon component used by the iconFactory to generate the tabs left icon adornment.
 */
export const Icon: React.FC<ITabProps> = ({ node }: ITabProps) => (
  <Tooltip title="Topological view">
    <HubOutlined />
  </Tooltip>
);
